import { HelperConstant } from '@helpers/HelperConstant';
import { isPlatform } from '@ionic/react';
import { IQuestionModel, IQuestionTypeModel } from 'models/QuestionType.Model'
import React, { InputHTMLAttributes, useEffect, useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap';
// import '../Questionnaire.css'


interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    data: Array<IQuestionTypeModel>,
    item: IQuestionTypeModel,
    index: any,
    elementRef: any,
    response: Array<IQuestionModel>,
    clickHandler: any,
}

function MultiSelectQuestions({ data, item, index, elementRef, response, clickHandler, ...rest }: inputProps, ref) {

    const subQuestions = data.filter(x => x.ParentId === item.Identifier);
    const [isToggle, setIsToggle] = useState(false);
    const onToggleClick = async (toggleValue: boolean, option: IQuestionTypeModel) => {
        clickHandler(toggleValue, option);
        setIsToggle(!isToggle);
    };

    const toggleHandler = (key: boolean) => {
        setIsToggle(key);
    }

    useEffect(() => {
        toggleHandler(isToggle);
    }, [isToggle]);

    return (
        <React.Fragment>
            <Row>
                <Col xl="12" class="p-0 mb-15" key={index}>
                    {/* <IonGrid class="p-0 m-0"> */}
                    <Row>
                        <Col lg="12" xs="12">
                            <Row>
                                <Col className="text-center">
                                    <p className="questionaire-question">{item.DisplayName}</p>
                                </Col>
                            </Row>
                            <Row>
                                {subQuestions && item?.AnswerType === "Multi_Select" ? (
                                    subQuestions.map((option: IQuestionTypeModel, oIndex: any) => (
                                        <Col lg="3" md="4" xl="4" sm="6" xs="6" key={oIndex} className='text-center'>
                                            {(response?.find(x => x.QuestionnaireTemplateId === option.Id)?.Selected === true) ?
                                                (
                                                    <Card onClick={() => onToggleClick(false, option)} class="mb-1"  className={`border-2 ${option.AppreciateCalculation ? 'border-primary' : 'border-danger '}`} style={{ cursor: "pointer", height: '150px' }}>
                                                        <CardBody className='p-1'>
                                                            {(option && option.EnumName && option.ProductTypeId != 20) ?
                                                                <img className='pc-img ' alt={`sell-${option.DisplayName}`} src={require(`../../../assets/images/questionaire/icons/${option.EnumName}_selected.png`)} />
                                                                : ""
                                                            }
                                                            <br />
                                                            {!(isPlatform("android") || isPlatform("ios")) && <br />}
                                                            <p className="pv_questionnaire_name font-size-12" style={{ color: option.AppreciateCalculation ? '#2250b2' : '#FC3C3C' }}>
                                                                {option.DisplayName}
                                                            </p>
                                                        </CardBody>

                                                    </Card>
                                                )
                                                :
                                                (
                                                    <Card onClick={() => onToggleClick(true, option)} class="mb-1" color="" className="pc-card border-secondary border-1" style={{ cursor: "pointer", height: '150px', }}>
                                                        <CardBody className='p-1'>
                                                            {(option && option.EnumName && option.ProductTypeId != 20) ?
                                                                <img className='pc-img' alt={`sell-${option.DisplayName}`} src={require(`../../../assets/images/questionaire/icons/${option.EnumName}_notselected.png`)} />
                                                                : ""
                                                            }
                                                            <br />
                                                            {!(isPlatform("android") || isPlatform("ios")) && <br />}
                                                            <p className="pv_questionnaire_name font-size-12">
                                                                {option.DisplayName}
                                                            </p>
                                                        </CardBody>

                                                    </Card>
                                                )}
                                        </Col>
                                    )
                                    ))
                                    : ""}

                            </Row>
                        </Col>
                    </Row>
                    {/* </IonGrid> */}
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default MultiSelectQuestions
